import { useQuery, useMutation } from 'react-query';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { request } from '../utility/axios-utils';

const fetchSettings = (serviceId) => {
  return request({
    url: '/settings/getSettings/' + serviceId,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
  });
};
export const useSettingsDetailsData = (serviceId, enabled, onSuccess, onError) => {
  return useQuery('settingsdetails', () => fetchSettings(serviceId), {
    enabled,
    onSuccess,
    onError,
    refetchOnWindowFocus: false,
  });
};

export const useReviewDetailsData = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useQuery(
    'reviewDetails',
    () => {
      return axiosPrivate.get('/reviewDetails/');
    },
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    },
  );
};

export const useTransactionDetailsData = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();
  return useQuery(
    'transactionDetails',
    () => {
      return axiosPrivate.get('/transactionDetails/');
    },
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    },
  );
};

export const useUpdateAllStepCompleted = (onSuccess, onError) => {
  const axiosPrivate = useAxiosPrivate();

  return useMutation(
    () => axiosPrivate.post('/updateAllStepCompleted'),
    {
      onSuccess,
      onError,
    }
  );
};